import { features } from '@/mocks/data';

export default function FeatureSection() {
  return (
    <section id="features" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-4">
            核心功能
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            一站式文稿协作解决方案
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            从编辑到审阅，从版本管理到权限控制，一起草为团队提供完整的协同文稿创作体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="group p-6 md:p-8 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-300 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-primary-100 text-primary-600 rounded-lg mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}